import { action } from 'satcheljs';
import type { ComposeFormType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

/**
 * Closes the compose form and resets the state of the store depending on the shouldResetComposeStoreForUndo boolean
 */
export let closeComposeForm = action(
    'closeComposeForm',
    (
        shouldResetComposeStoreForUndo: boolean,
        isMeeting: boolean,
        shouldClosePopOutWindow: boolean = true
    ) => ({
        shouldResetComposeStoreForUndo,
        isMeeting,
        shouldClosePopOutWindow,
    })
);

/**
 * Presents the undo notification for the compose form
 */
export let showUndoNotificationForCompose = action(
    'showUndoNotificationForCompose',
    (composeFormType: ComposeFormType) => ({
        composeFormType,
    })
);

/**
 * Discards the event creation form modal with a confirmation
 */
export let discardEvent = action('discardEvent', (shouldShowNotification: boolean = true) => ({
    shouldShowNotification,
}));

/**
 * Provides a modal confirmation dialog, after the user tries to discard the event, that closes the compose form
 * when the user confirms or leaves the form open if the user denies
 */
export let presentDiscardClosureConfirmation = action(
    'presentDiscardClosureConfirmation',
    (callBack?: () => void) => ({
        callBack,
    })
);

/**
 * Discards any attachments which have been added during compose
 */
export const discardAddedAttachments = action('discardAddedAttachments');
